import React, { useEffect, useState } from "react";
import Select from "react-select";
import { generatePDFAndDownload, ListOfPdfs } from "../../../../../api";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import Modal from "../../../../components/modal";
import styles from "./styles.module.scss";
import toast from "react-hot-toast";
import useUserStore from "../../../../stores/user";
import useApplicationStore from "../../../../stores/application";

function GenerateDownload({ open, onClose }) {
  const activeApp = useApplicationStore((state) => state.activeApp);
  const loggedInUser = useUserStore((state) => state.user);
  const [activeBankProcessors, setActiveBankProcessors] = useState([]);
  const [show_spinner, setShowSpinner] = useState(false);
  const [list_of_pdfs, setListOfPdfs] = useState({});
  const [files_options, setFileOptions] = useState([]);

  const [selectedBank, setSelectedBank] = useState({});
  const [selectedFiles, setSelectedFiles] = useState();

  const onChangeTypeofBanks = (value) => {
    setSelectedBank(value);
    let processor_files = list_of_pdfs[value.value];
    let applications = processor_files.application.map((app) => ({
      value: app,
      label: app,
    }));
    let addendums = processor_files.addendums.map((addendum) => ({
      value: addendum,
      label: addendum,
    }));
    let file_ops = [
      {
        label: "Applications",
        options: applications,
      },
      {
        label: "Addendums",
        options: addendums,
      },
    ];
    setFileOptions(file_ops);
  };

  const onChangeFileSelect = (value) => {
    setSelectedFiles(value);
  };

  const handleSubmit = () => {
    if (selectedBank.value) {
      const toastId = toast.loading("Generating PDF...");
      setShowSpinner(true);
      generatePDFAndDownload({
        slug: activeApp.editslug,
        pdf_file_name: selectedFiles.value,
      }).then((res) => {
        setShowSpinner(false);
        if (res.status) {
          toast.success("PDF Generated Successfully", { id: toastId });
          window.open(res.fileUrl, "_blank", "noreferrer");
        } else {
          toast.error("Something went wrong", { id: toastId });
        }
        onClose();
      })
        .catch((err) => {
          setShowSpinner(false);
          toast.error("Something went wrong", { id: toastId });
          onClose();
        });
    }
  };

  useEffect(() => {
    ListOfPdfs().then((res) => {
      setListOfPdfs(res?.data?.bank_file_mapping);
      let processor_options = Object.entries(res?.data?.bank_file_mapping).map(
        ([key, val]) => {
          return {
            label: key,
            value: key,
          };
        },
      );

      if (loggedInUser?.is_ems_user) {
        processor_options = processor_options.filter((item) =>
          item.label.includes("EMS"),
        );
      }
      console.log("User", loggedInUser);
      setActiveBankProcessors(processor_options);
    });
  }, []);

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      header={""}
    >
      <div className={styles.modalBody}>

        <h6 className={styles.heading} >Generate and Download</h6>

        <div className={styles.fieldGroup}>
          <div>
            <label>Document</label>
            {activeBankProcessors.length ? (
              <Select
                name="colors"
                isLoading={show_spinner}
                isDisabled={show_spinner}
                options={activeBankProcessors}
                onChange={onChangeTypeofBanks}
                className={styles.selectInput}
                classNames={{
                  control: () => styles.selectControl, // Map the CSS Module class
                }}
                classNamePrefix="select"
              />
            ) : (
              <></>
            )}
          </div>

          <div>
            <label>Document Type</label>
            {selectedBank ? (
              <>
                <br />
                <Select
                  name="files"
                  isLoading={show_spinner}
                  isDisabled={show_spinner}
                  options={files_options}
                  onChange={onChangeFileSelect}
                  className={styles.selectInput}
                  classNames={{
                    control: () => styles.selectControl, // Map the CSS Module class
                  }}
                  classNamePrefix="select"
                />
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>

      <div className={styles.modalFooter}>
        <ButtonIcon textColor="#254FE2" onClick={onClose}>
          Cancel
        </ButtonIcon>
        <ButtonIcon
          bgColor={"#4C70EF"}
          textColor="#FFF"
          disabled={show_spinner}
          onClick={handleSubmit}
        >
          Download
        </ButtonIcon>
      </div>
    </Modal>
  );
}

export default GenerateDownload;
